module.exports = __webpack_public_path__ + "static/media/web-analytics.0603f967.jpg";